"use strict";

module.exports = require("./is-implemented")() ? require("ext/global-this").Symbol : require("./polyfill");